export default __webpack_public_path__ + "static/media/bateria.0b997423.png";